import { OptimizationResult } from '../types';

export function generatePalletsCSV(result: OptimizationResult): string {
  const rows = [
    // Summary section
    ['Pallet Optimization Results'],
    [''],
    ['Summary'],
    [`Total Pallets,${result.totalPallets}`],
    [`Efficiency,${result.efficiency.toFixed(1)}%`],
    [`Pallet Length (cm),${result.palletDimensions.length}`],
    [`Pallet Width (cm),${result.palletDimensions.width}`],
    [`Pallet Max Height (cm),${result.palletDimensions.maxHeight}`],
    [''],
    // Detailed results
    ['Pallet', 'Layer', 'Product ID', 'Box Count', 'Layer Height (cm)', 'Pallet Height (cm)']
  ];

  result.pallets.forEach((pallet, palletIdx) => {
    pallet.layers.forEach((layer, layerIdx) => {
      const productId = layer.boxes[0]?.asin || '';
      const boxCount = layer.boxes.length;
      rows.push([
        `Pallet ${palletIdx + 1}`,
        `Layer ${layerIdx + 1}`,
        productId,
        boxCount.toString(),
        layer.height.toFixed(1),
        pallet.totalHeight.toFixed(1)
      ]);
    });
  });

  return rows.map(row => row.join(',')).join('\n');
}

export function downloadPalletsCSV(result: OptimizationResult) {
  const csv = generatePalletsCSV(result);
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pallets_export.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
} 